import React from 'react';

import { Locale } from '@frontend/common';
import SelectInputV2, { SelectInputV2Props } from '../select/select-input-v2/select-input-v2.component';
import useLanguageSelect from './language-select.controller';

const ID = 'language-select';

export interface LanguageSelectProps extends Omit<SelectInputV2Props<Locale>, 'options'> {}

export const LanguageSelect = (props: LanguageSelectProps) => {
    const viewProps = useLanguageSelect(props);

    return (
        <SelectInputV2
            {...props}
            id={props.id || ID}
            label={props.label || 'Language'}
            className={props.className}
            required={props.required}
            options={viewProps.options}
            onSelect={props.onSelect}
            value={typeof viewProps.value === 'string' ? viewProps.value : viewProps.value?.value}
            disabled={props.disabled}
            isClearable={props.isClearable}
        />
    );
};
